export const calculateHighestTee = (array) => {
  let tempArr = [];

  for (let a = 0; a < array.length; a++) {
    tempArr.push(array[a][array[a].default_tee]);
    array[a].advantage = true;
  }

  let minVal = Math.min(...tempArr);

  let indexOfMinVal = tempArr.indexOf(minVal);

  if (indexOfMinVal !== -1) {
    array[indexOfMinVal].advantage = false;
  }

  return [array, minVal];
};
